__turbopack_context__.v({
  "content": "alreadyButton-module__ZQTrLW__content",
  "dialogBody": "alreadyButton-module__ZQTrLW__dialogBody",
  "eyebrow": "alreadyButton-module__ZQTrLW__eyebrow",
  "ownLine": "alreadyButton-module__ZQTrLW__ownLine",
});
